module.exports = __webpack_public_path__ + "static/corrie-1-1014x676-d666fbf862b3706f5abaa270fc2adbda.jpg";